import { QueryKeys } from '../../utils/queryKeys';

export const chapterByModuleKeys = {
    all: [QueryKeys.GET_CHAPTER_BY_MODULE],
    getChapterByModuleKeys: () => [...chapterByModuleKeys.all],
};